<template>
  <div class="store">
    <DomainTree v-if="$route.path === '/storeinformation/storemanagement'" @isCollapse-treedata="isCollapseTreedata" @addcheck-treedata="getTreeCheckData" :checkDomainId="domainId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
    <div v-if="$route.path === '/storeinformation/storemanagement'" class="right" :style="styleRight">
      <div class="operation">
        <div class="operationBtn">
          <el-dropdown trigger="click">
            <el-button :disabled="delDisabled">{{$t('LanguageLib.BATCH_SET')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.DELETE')" @click.native.prevent="delDomainData">{{$t('LanguageLib.DELETE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.ADD_TAG')" @click.native.prevent="addTag('0')">{{$t('LanguageLib.ADD_TAG')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.Rebinding')" @click.native.prevent="Rebinding">{{$t('LanguageLib.Rebinding')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="addStore">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-dropdown trigger="click">
            <el-button type="primary">{{$t('LanguageLib.ImportOrExport')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_TEMPLATE')" @click.native.prevent="downExcal">{{$t('LanguageLib.DOWNLOAD_TEMPLATE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.CLICK_UPLOAD')">
                <el-upload
                  class="upload"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="onSuccess"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">{{$t('LanguageLib.IMPORT_SHOP')}}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.EXPORT_STORE')" @click.native.prevent="exportExcal">{{$t('LanguageLib.EXPORT_STORE')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="operationSearch">
          <i @click="drawerOpen" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan}">&#xe624;</i>
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotal }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
          <i v-show="isSearch" @click="clearSearchData" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          :default-sort="defaultSort"
          ref="table"
          style="width: auto;"
          v-loading="loading"
          height="100%">
          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column
            prop="storeCode"
            :label="$t('LanguageLib.SHOP_NUMBER')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="storeCode">{{scope.row.storeCode}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeCode">{{scope.row.storeCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            prop="storeName"
            :label="$t('LanguageLib.STORE_NAME')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="storeName" v-html="$commonfun.RenderWxName('departmentName', scope.row.storeName)"></span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeName" v-html="$commonfun.RenderWxName('departmentName', scope.row.storeName)"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="storeAbbName"
            :label="$t('LanguageLib.SHOP_ENGLISH_NAME')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="storeAbbName">{{scope.row.storeAbbName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeAbbName">{{scope.row.storeAbbName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="domainPaths"
            :label="$t('LanguageLib.ORGANIZATION_PATH')"
            sortable="custom"
            min-width="260">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="domainPaths" v-html="scope.row.pathHtml"></span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="domainPaths" v-html="scope.row.pathHtml"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="typeName"
            :label="$t('LanguageLib.SHOP_TYPE')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="typeName">{{scope.row.typeName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="typeName">{{scope.row.typeName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="brandNameCn"
            :label="$t('LanguageLib.BRAND')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="brandNameCn">{{scope.row.brandNameCn}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="brandNameCn">{{scope.row.brandNameCn}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="currencyType"
            :label="$t('LanguageLib.z_info_common_000007')"
            sortable="custom"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="currencyType">{{scope.row.currencyType}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="currencyType">{{scope.row.currencyType}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="storeLang"
            :label="$t('LanguageLib.z_info_common_000006')"
            sortable="custom"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="storeLang">{{scope.row.storeLang}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeLang">{{scope.row.storeLang}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="storeEmail"
            :label="$t('LanguageLib.SHOP_MAILBOX')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="storeEmail">{{scope.row.storeEmail}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="storeEmail">{{scope.row.storeEmail}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.Is_Enterprise_Micro_Synchronization')"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.QW_BIND_STATUS')"
            min-width="250">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="authStatus">{{$commonfun.authStatus(scope.row.authStatus)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="authStatus">{{$commonfun.authStatus(scope.row.authStatus)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="areaSquare"
            :label="$t('LanguageLib.STORE_INFO_AREASQUARE')"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="areaSquare">{{scope.row.areaSquare}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="areaSquare">{{scope.row.areaSquare}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            prop="openDate"
            :label="$t('LanguageLib.STORE_INFO_OPENDATE')"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="openDate">{{$commonfun.formatDate(scope.row.openDate, '2')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="openDate">{{$commonfun.formatDate(scope.row.openDate, '2')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="decorationDate"
            :label="$t('LanguageLib.STORE_INFO_DECORATIONDATE')"
            sortable="custom"
            min-width="250">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="decorationDate">{{$commonfun.formatDate(scope.row.decorationDate, '2')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="decorationDate">{{$commonfun.formatDate(scope.row.decorationDate, '2')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.UPDATE_TIME')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate, '1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="130">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editStore(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                @click.native.prevent="addTag('1', scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.SHOP_LABEL')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe600;</i>
              </el-button>
              <el-dropdown trigger="click" style="margin-left: 10px;">
                <el-button
                  type="text"
                  style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                  <i class="iconfont">&#xe617;</i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :title="$t('LanguageLib.STORE_FLOOR_PLANS')" @click.native.prevent="upLoadAttachment(scope.row, scope.$index, tableData)"><i class="iconfont">&#xe60b;</i>{{$t('LanguageLib.STORE_FLOOR_PLANS')}}</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.authStatus === 1 && !scope.row.fromQy" :title="$t('LanguageLib.Rebinding')" @click.native.prevent="rebindingItem(scope.row, scope.$index, tableData)"><i class="iconfont">&#xe618;</i>{{$t('LanguageLib.Rebinding')}}</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.authStatus !== 1 || scope.row.fromQy" :title="$t('LanguageLib.Rebinding')" @click.native.prevent="rebindingItemError(scope.row, scope.$index, tableData)"><i style="color: #dcdfe6;" class="iconfont">&#xe618;</i><span style="color: #dcdfe6;">{{$t('LanguageLib.Rebinding')}}</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button
                @click.native.prevent="upLoadAttachment(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.STORE_FLOOR_PLANS')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60b;</i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <el-drawer
      v-if="$route.path === '/storeinformation/storemanagement'"
      :visible.sync="drawer"
      :show-close="true"
      :modal="false"
      :wrapperClosable="false"
      size="420px"
      :with-header="false">
      <div style="overflow: hidden">
        <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
        <el-button @click="drawerClose" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
      </div>
      <div class="filterContent">
        <p class="drawerText">{{$t('LanguageLib.SHOP_TYPE')}}</p>
        <el-select style="width: 100%;" v-model="checkedStoreTypeData" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in searchStoreTypeList"
            :key="item.id"
            :label="item.typeName"
            :value="item.id">
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.MODE_OF_OPERATION')}}</p>
        <el-select style="width: 100%;" v-model="checkedModeOperationData" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in searchModeOperationList"
            :key="item.typeValue"
            :label="item.typeDes"
            :value="item.typeValue">
          </el-option>
        </el-select>
        <p class="drawerText">{{$t('LanguageLib.BRAND')}}</p>
        <el-select style="width: 100%;" v-model="checkedBrandData" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option
            v-for="item in searchBrandList"
            :key="item.id"
            :label="item.brandNameCn"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div style="position: absolute;bottom: 68px;right: 20px;">
        <el-button @click="resetSearchData" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
        <el-button @click="searchOrgList" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
      </div>
    </el-drawer>
    <!--导出excal-->
    <el-dialog :title="$t('LanguageLib.SELECT_EXPORT_FIELD')" :visible.sync="dialogExcal" class="ExcalDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
      <div class="checkFiled">
        <el-form>
          <div class="contentTop">
              <el-radio v-model="allField" :label="item.label" v-for="item in FieldData" :key="item.label" @change="handleCheckAllChange">{{item.name}}</el-radio >
          </div>
          <div class="basicsField">
            <h4>{{$t('LanguageLib.BASE_FIELD')}}</h4>
            <div class="basicsFieldChild">
              <el-checkbox-group v-model="checkedFields">
                <el-checkbox v-for="item in Fields" :label="item" :key="item" :disabled="allField == '2'">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="customField">
            <h4>{{$t('LanguageLib.CUSTOM_FIELD')}}</h4>
          </div>
        </el-form>
      </div>
      <div class="showFiled">
        <p style="color: #999999;">{{$t('LanguageLib.CURRENT_SELECT_FIELD')}}</p>
        <ul>
          <li v-for="item in checkedFields" :key="item"><span>{{item}}</span><i class="el-icon-close" @click="delField(item)" v-if="allField == '1'"></i></li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
    <router-view v-if="$route.path !== '/storeinformation/storemanagement'"></router-view>
  </div>
</template>

<script>
import storeinformationApi from '../../api/storeinformation'
import DomainTree from '@/components/DomainTree.vue'
import baseUrl from '@/utils/base'
export default {
  name: 'domainsetting',
  components: { DomainTree },
  props: {
    msg: String
  },
  data () {
    return {
      uploadApi: baseUrl.uploadApi, // 上传地址
      dialogAttachment: false, // 是否显示上传附件弹框
      loading: true, // loading状态
      isSearch: false, // 是否为搜索状态
      dialogExcal: false, // 是否显示导出excal弹框
      orgTreeData: [], // 组织树数据
      orgData: [], // 组织树源数据
      oneNodeArr: [], // 一级组织下的数据
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      shaixuan: false, // 漏斗图是否高亮
      formData: { path: 'images' },
      getOrgDataListFun: (pageIndex, pageSize, domainId, searchVal, sort, sortOrder, StoreTypes, ManagerType, BrandIds) => {
        this.loading = true
        // 请求列表接口数据
        if (domainId === '') {
          domainId = null
        }
        storeinformationApi.getStoreDataList('post', '/Store/PageList', { pageIndex, pageSize, domainId, searchVal, sort, sortOrder, StoreTypes, ManagerType, BrandIds })
          .then(res => {
            this.tableData = res.data.data
            for (let i = 0; i < this.tableData.length; i++) {
              var pathstr = this.tableData[i].domainPaths
              if (pathstr) {
                this.tableData[i].pathArr = this.tableData[i].domainPaths.split('/')
              } else {
                this.tableData[i].pathArr = []
              }
              if (this.tableData[i].pathArr.length > 0) {
                var pathHtml = ''
                for (var k in this.tableData[i].pathArr) {
                  var item = this.tableData[i].pathArr[k]
                  if (item.indexOf('wx|') > -1) {
                    if ((k * 1) === (this.tableData[i].pathArr.length - 1)) {
                      pathHtml += this.$commonfun.RenderWxName('departmentName', item)
                    } else {
                      pathHtml += this.$commonfun.RenderWxName('departmentName', item) + '/'
                    }
                  } else {
                    if ((k * 1) === (this.tableData[i].pathArr.length - 1)) {
                      pathHtml += '<span>' + item + '</span>'
                    } else {
                      pathHtml += '<span>' + item + '/</span>'
                    }
                  }
                }
                this.tableData[i].pathHtml = pathHtml
              } else {
                this.tableData[i].pathHtml = ''
              }
              if (this.tableData[i].storeLang === 0) {
                this.tableData[i].storeLang = this.$t('LanguageLib.SIMPLIFIED_CHINESE')
              } else if (this.tableData[i].storeLang === 1) {
                this.tableData[i].storeLang = this.$t('LanguageLib.TRADITIONAL_CHINESE')
              } else if (this.tableData[i].storeLang === 2) {
                this.tableData[i].storeLang = this.$t('LanguageLib.ENGLISH')
              } else if (this.tableData[i].storeLang === 3) {
                this.tableData[i].storeLang = this.$t('LanguageLib.JAPANESE')
              } else if (this.tableData[i].storeLang === 4) {
                this.tableData[i].storeLang = this.$t('LanguageLib.KOREAN')
              } else {
                this.tableData[i].storeLang = ''
              }
            }
            this.pageTotal = res.data.pageCount
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      domainId: '', // 列表请求domainId
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 'updateDate', // 排序字段
      sortOrder: 'desc', // 排序方式逆序：desc正序asc
      delDisabled: true, // 删除按钮默认禁用
      selectDomainData: [], // 选中的组织数据
      drawer: false, // 抽屉框默认收起
      searchStoreTypeList: [], // 抽屉框店铺类型列表
      checkedStoreTypeData: '', // 抽屉框店铺类型选中
      searchBrandList: [], // 抽屉框所属品牌列表
      checkedBrandData: '', // 抽屉框所属品牌选中
      searchModeOperationList: [], // 抽屉框经营方式列表
      checkedModeOperationData: '', // 抽屉框经营方式选中
      checkedStoreTypeDataOld: '', // 抽屉框店铺类型选中传参
      checkedBrandDataOld: '', // 抽屉框所属品牌选中传参
      checkedModeOperationDataOld: -1, // 抽屉框经营方式选中传参
      styleRight: 'width: 80%;margin-left: 20%', // right默认宽度
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'updateDate', // 记录前一次的prop值
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.checkDomainId = this.domainId
        newQuery.searchText = this.searchText
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder
        newQuery.checkedStoreTypeData = this.checkedStoreTypeData
        newQuery.checkedModeOperationData = this.checkedModeOperationData
        newQuery.checkedBrandData = this.checkedBrandData
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      },
      FileData: {
        FileName: '', // 文件名称
        FilePath: '', // 文件地址
        EnumImportType: 2000 // 导入类型2000为店铺导入
      }, // 文件导入参数
      loadingSave: false, // 保存按钮加loding
      allField: '2', // 导出excal-所有字段
      isIndeterminate: false, // 导出excal-所有字段勾选框状态
      FieldData: [
        // {
        //   name: this.$t('LanguageLib.SELECT_VIEW'),
        //   label: '1'
        // },
        {
          name: this.$t('LanguageLib.EXPORT_FOLLOW_UP'),
          label: '2'
        }
      ], // 导出查看/导出跟进
      checkedFields: [this.$t('LanguageLib.MODE_OF_OPERATION'), this.$t('LanguageLib.DEALER_CORPORATE'), this.$t('LanguageLib.BUSINESS_HOURS_OPENING'), this.$t('LanguageLib.BUSINESS_HOURS_CLOSE'), this.$t('LanguageLib.SHOP_ADRESS'), this.$t('LanguageLib.SHOP_MAILBOX'), this.$t('LanguageLib.STORE_PHONE'), this.$t('LanguageLib.STORE_CONTACT'), this.$t('LanguageLib.CONTACT_NUMBER1'), this.$t('LanguageLib.z_info_common_000099'), this.$t('LanguageLib.REMARK2')], // 已选中的字段
      Fields: [this.$t('LanguageLib.MODE_OF_OPERATION'), this.$t('LanguageLib.DEALER_CORPORATE'), this.$t('LanguageLib.BUSINESS_HOURS_OPENING'), this.$t('LanguageLib.BUSINESS_HOURS_CLOSE'), this.$t('LanguageLib.SHOP_ADRESS'), this.$t('LanguageLib.SHOP_MAILBOX'), this.$t('LanguageLib.STORE_PHONE'), this.$t('LanguageLib.STORE_CONTACT'), this.$t('LanguageLib.CONTACT_NUMBER1'), this.$t('LanguageLib.z_info_common_000099'), this.$t('LanguageLib.REMARK2')]
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.domainId = this.$route.query.checkDomainId
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort
      this.sortOrder = this.$route.query.sortOrder
      this.checkedStoreTypeData = this.$route.query.checkedStoreTypeData
      this.checkedModeOperationData = this.$route.query.checkedModeOperationData === '' ? '' : Number(this.$route.query.checkedModeOperationData)
      this.checkedBrandData = this.$route.query.checkedBrandData
      if (this.sortOrder === 'asc') {
        this.defaultSort = { prop: this.sort, order: 'ascending' }
        this.prevSort = 'ascending'
      } else {
        this.defaultSort = { prop: this.sort, order: 'descending' }
        this.prevSort = 'descending'
      }
      this.prevProp = this.sort
    }
    if (this.checkedStoreTypeData === '' && this.checkedModeOperationData === '' && this.checkedBrandData === '') {
      this.isSearch = false
      this.shaixuan = false
    } else {
      this.isSearch = true
      this.shaixuan = true
    }
    // 获取组织树列表
    storeinformationApi.gettreelist('get', '/sysdomain/domainTree')
      .then(res => {
        this.orgData = res.data
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
        if (res.data.length > 0 && this.$route.query.fromPath === undefined) {
          // 'nextTick()' 下次dom更新时触发回调函数
          // 默认点击
          this.$nextTick().then(() => {
            if (document.querySelector('.el-tree-node__content')) {
              document.querySelector('.el-tree-node__content').click()
            }
          })
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    // 默认获取所有数据
    this.checkedStoreTypeDataOld = this.checkedStoreTypeData === '' ? [] : this.checkedStoreTypeData.split(' ')
    this.checkedModeOperationDataOld = this.checkedModeOperationData === '' ? -1 : this.checkedModeOperationData
    this.checkedBrandDataOld = this.checkedBrandData === '' ? [] : this.checkedBrandData.split(' ')
    this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
  },
  methods: {
    filterDomain () {
      storeinformationApi.getSearchName('post', '/QYUser/Search',
        {
          ownerId: this.$commonfun.localStorage.getitem('ownerId'),
          ownerCode: this.$commonfun.localStorage.getitem('ownerCode'),
          search: this.filterText,
          queryType: 2
        }, 'Api')
        .then(res => {
          this.searchTreeIds = res.data
          this.$refs.tree.filter(this.filterText)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    filterNode (value, data) {
      if (!value) {
        return true
      } else {
        return ''
      }
    },
    // 树组件传过来的数据
    getTreeCheckData (data) {
      this.domainId = data.id
      // 请求列表接口数据
      this.currentPage = 1
      this.pageSize = 20
      this.updataRouteQuery()
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 显示隐藏组织树
    isCollapseTreedata (data) {
      this.$commonfun.console.log(data)
      if (data === true) {
        this.styleRight = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRight = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.sortOrder = 'asc'
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.sortOrder = 'desc'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.sortOrder = column.column.order === 'descending' ? 'desc' : 'asc'
      }
      this.sort = column.prop
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.updataRouteQuery()
      this.currentPage = 1
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 删除店铺数据
    delDomainData () {
      this.$commonfun.confirm(this.$t('LanguageLib.InfoIsDeleteStore'), this.$t('LanguageLib.DELETE_STORE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeinformationApi.DelStoreList('post', '/store/delete', this.selectDomainData)
            .then(res => {
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
              if (res.data.fail === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '成功删除 ' + res.data.succ + '个,有' + res.data.fail + '个无法删除'
                })
              }
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 组织选择
    selectionChange (selection) {
      this.selectDomainData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectDomainData.push(selection[i].id)
      }
      if (this.selectDomainData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 过滤点击
    drawerOpen () {
      this.drawer = true
      this.shaixuan = true
      // 获取店铺类型
      storeinformationApi.GetStoreType('get', '/store/GetStoreType', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          this.searchStoreTypeList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
      // 获取店铺所属品牌
      storeinformationApi.GetBrandInfo('get', '/store/GetBrandInfo', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          this.searchBrandList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
      // 获取经营方式
      storeinformationApi.GetManageType('get', '/store/GetManageType', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          this.searchModeOperationList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 过滤关闭
    drawerClose () {
      this.drawer = false
      this.shaixuan = false
      //    this.checkedStoreTypeData = ''
      //    this.checkedModeOperationData = ''
      //    this.checkedBrandData = ''
    },
    // 点击精确搜索
    searchOrgList () {
      this.drawer = false
      this.isSearch = true
      this.updataRouteQuery()
      this.checkedStoreTypeDataOld = this.checkedStoreTypeData === '' ? [] : this.checkedStoreTypeData.split(' ')
      this.checkedModeOperationDataOld = this.checkedModeOperationData === '' ? -1 : this.checkedModeOperationData
      this.checkedBrandDataOld = this.checkedBrandData === '' ? [] : this.checkedBrandData.split(' ')
      this.currentPage = 1
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 清空搜索数据
    resetSearchData () {
      this.checkedStoreTypeData = ''
      this.checkedModeOperationData = ''
      this.checkedBrandData = ''
    },
    // 清除搜索状态
    clearSearchData () {
      this.shaixuan = false
      this.isSearch = false
      this.checkedStoreTypeData = ''
      this.checkedModeOperationData = ''
      this.checkedBrandData = ''
      this.checkedStoreTypeDataOld = []
      this.checkedModeOperationDataOld = -1
      this.checkedBrandDataOld = []
      this.currentPage = 1
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 点击添加店铺
    addStore () {
      this.$router.push('/storeinformation/storemanagement/addstore?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedStoreTypeData=' + this.checkedStoreTypeData + '&checkedModeOperationData=' + this.checkedModeOperationData + '&checkedBrandData=' + this.checkedBrandData + '&type=add')
    },
    // 编辑店铺
    editStore (data, index, tableData) {
      this.$router.push('/storeinformation/storemanagement/addstore?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedStoreTypeData=' + this.checkedStoreTypeData + '&checkedModeOperationData=' + this.checkedModeOperationData + '&checkedBrandData=' + this.checkedBrandData + '&type=edit&id=' + data.id)
    },
    // 单个重新同步提示
    rebindingItemError (data, index, tableData) {
      this.$message({
        type: 'info',
        message: this.$commonfun.stringFormat(this.$t('LanguageLib.Rebinding_MSG2'), this.$t('LanguageLib.SHOP'))
      })
    },
    // 单个重新同步
    rebindingItem (data, index, tableData) {
      this.$commonfun.confirm(this.$t('LanguageLib.Rebinding_MSG1'), this.$t('LanguageLib.Rebinding'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeinformationApi.AgainSync('post', '/store/againSync', [data.id])
            .then(res => {
              this.$commonfun.console.log(res)
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              this.$message({
                type: 'success',
                message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_SUCCESS'), this.$t('LanguageLib.Rebinding'))
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
              this.$message({
                type: 'error',
                message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_FAIL'), this.$t('LanguageLib.Rebinding'))
              })
            })
        }).catch(() => {
        })
    },
    // 重新同步
    Rebinding () {
      this.$commonfun.confirm(this.$t('LanguageLib.Rebinding_MSG1'), this.$t('LanguageLib.Rebinding'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeinformationApi.AgainSync('post', '/store/againSync', this.selectDomainData)
            .then(res => {
              console.log(res)
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              if (res.data.successCount === 0) {
                this.$message({
                  type: 'error',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_FAIL'), this.$t('LanguageLib.Rebinding'))
                })
              } else if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_SUCCESS'), this.$t('LanguageLib.Rebinding'))
                })
              } else {
                this.$message({
                  type: 'info',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.Rebinding'), this.$t('LanguageLib.Rebinding'))
                })
              }
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
        })
    },
    // 批量添加店铺标签
    addTag (type, data, index, tableData) {
      this.$commonfun.console.log(type)
      this.$commonfun.console.log(data)
      this.$commonfun.console.log(index)
      this.$commonfun.console.log(tableData)
      // type: 0 批量添加标签  1 单个添加店铺标签
      if (type === '0') {
        this.$router.push('/storeinformation/storemanagement/addtag?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedStoreTypeData=' + this.checkedStoreTypeData + '&checkedModeOperationData=' + this.checkedModeOperationData + '&checkedBrandData=' + this.checkedBrandData + '&type=add&tagType=0&StoreIdList=' + this.selectDomainData)
      }
      if (type === '1') {
        this.$router.push('/storeinformation/storemanagement/addtag?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedStoreTypeData=' + this.checkedStoreTypeData + '&checkedModeOperationData=' + this.checkedModeOperationData + '&checkedBrandData=' + this.checkedBrandData + '&type=add&tagType=1&StoreIdList=' + data.id + '&storeName=' + data.storeName)
      }
    },
    // 上传附件
    upLoadAttachment (data, index, tableData) {
      this.$router.push('/storeinformation/storemanagement/upload?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.domainId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedStoreTypeData=' + this.checkedStoreTypeData + '&checkedModeOperationData=' + this.checkedModeOperationData + '&checkedBrandData=' + this.checkedBrandData + '&type=add&storeid=' + data.id)
    },
    // 导出excal
    exportExcal () {
      this.dialogExcal = true
    },
    // 导出跟进字段全部选中
    handleCheckAllChange () {
      this.checkedFields = JSON.parse(JSON.stringify(this.Fields))
    },
    // 取消选中字段
    delField (type) {
      for (let i = 0; i < this.checkedFields.length; i++) {
        if (type === this.checkedFields[i]) {
          this.checkedFields.splice(i, 1)
        }
      }
    },
    // 关闭对话框
    closeDialog () {
      this.dialogExcal = false
    },
    // 下载导入模板
    downExcal () {
      storeinformationApi.sysdomainDownExcal('get', '/basicdata/exceltemplate?template=5')
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
          })
          this.dialogExcal = false
          var filename = 'Store' + '_' + this.$commonfun.localStorage.getitem('lang') + '.xlsx'
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(new Blob([res.data]))
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    },
    // 导入模板
    headers () {
      return { token: this.$commonfun.localStorage.getitem('token'), lang: this.$commonfun.localStorage.getitem('lang') }
    },
    handlePreview (file) {
    },
    beforeUpload (file) {
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      if (type !== '.xlsx' && type !== '.xls' && type !== '.XLSX' && type !== '.XLS') {
        this.$message.success(this.$t('LanguageLib.FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL'))
        return false
      }
    },
    // 上传失败
    onError (file) {
      this.$message.success(this.$t('LanguageLib.UPLOAD_FAILED'))
    },
    // 上传成功
    onSuccess (file, response) {
      this.FileData.FilePath = file[0]
      this.FileData.FileName = response.name
      storeinformationApi.importinfoImport('post', '/importinfo/create', this.FileData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT')
          })
          this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 导出Excal
    submit () {
      this.loadingSave = true
      if (this.$commonfun.localStorage.getitem('qyuser') === 'false') {
        storeinformationApi.sysdomainExport('post', '/Store/Export', {
          domainId: this.domainId === '' ? null : this.domainId,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          searchVal: this.searchText,
          sort: this.sort,
          sortOrder: this.sortOrder,
          StoreTypes: this.checkedStoreTypeDataOld,
          ManagerType: this.checkedModeOperationDataOld,
          BrandIds: this.checkedBrandDataOld
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
            })
            this.dialogExcal = false
            // 获取当前日期
            var today = new Date()
            var Month = today.getMonth() + 1
            var day = today.getDate()
            if (Month < 10) {
              Month = '0' + Month
            }
            if (day < 10) {
              day = '0' + day
            }
            var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
            var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
            var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            var milliSeconds = today.getMilliseconds()
            var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
            var filename = 'Store' + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingSave = false
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      } else {
        // 企微登录扫码导出
        storeinformationApi.ExportWXTranslateStore('post', '/Store/exportWXTranslate', {
          domainId: this.domainId === '' ? null : this.domainId,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          searchVal: this.searchText,
          sort: this.sort,
          sortOrder: this.sortOrder,
          StoreTypes: this.checkedStoreTypeDataOld,
          ManagerType: this.checkedModeOperationDataOld,
          BrandIds: this.checkedBrandDataOld
        })
          .then(res => {
            var time = 0
            var timeId = setInterval(() => {
              time++
              storeinformationApi.ExportWXTranslateStore('get', '/export/GetWXTranslateURL', {
                jobId: res.data.jobId
              })
                .then(result => {
                  if (result.data.url !== null) {
                    window.clearInterval(timeId)
                    this.$message({
                      type: 'success',
                      message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
                    })
                    this.dialogExcal = false
                    // 获取当前日期
                    var today = new Date()
                    var Month = today.getMonth() + 1
                    var day = today.getDate()
                    if (Month < 10) {
                      Month = '0' + Month
                    }
                    if (day < 10) {
                      day = '0' + day
                    }
                    var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
                    var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
                    var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
                    var milliSeconds = today.getMilliseconds()
                    var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
                    var filename = 'Store' + '_' + currentDay + '.xlsx'
                    var a = document.createElement('a')
                    a.href = result.data.url
                    a.download = filename
                    a.click()
                    window.URL.revokeObjectURL(result.data.url)
                    this.loadingSave = false
                  } else {
                    if (time === 5) {
                      window.clearInterval(timeId)
                      this.dialogExcal = false
                      this.loadingSave = false
                      this.$message({
                        type: 'error',
                        message: this.$t('LanguageLib.EXPORT_FAILED')
                      })
                    }
                  }
                })
                .catch(err => {
                  this.loadingSave = false
                  this.$commonfun.console.log(err)
                })
            }, 2000)
          })
          .catch(err => {
            this.loadingSave2 = false
            this.$commonfun.console.log(err)
          })
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.store{
  width:100%;
  height: 100%;
}
.store .left{
  background: #fff;
  width: 20%;
  float:left;
  height: 100%;
  border-right: 1px solid #f2f2f2;
  .treeBox{
    height: calc( 100% - 50px );
    overflow: auto;
    width: 100%;
  }
  .fifter{
    padding: 10px 0 10px 6%;
    line-height: 30px;
   .el-input{
      width: 60%;
    }
    .el-button--text{
      margin-left: 2.5%;
      padding: 2% 0;
      width: 20%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.store .right{
  width: 80%;
  margin-left: 20%;
  height: 100%;
  .operation{
    background: #fff;
    height: 30px;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .operationBtn{
      width: auto;
      display: inline-block;
      float:left;
      position: relative;
      .el-button{
        height: 30px;
        padding: 7px 20px;
      }
      .BatchSetting{
        background: #fff;
        color: #666666;
        position:absolute;
        left: 0;
        top: 30px;
        width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
      }
      .exportType{
        background: #fff;
        color: #666666;
        position:absolute;
        right: 0;
        top: 30px;
        min-width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
          padding: 0 10px;
        }
        .upload{
          position: absolute;
          top: 30px;
          width: 100%;
          opacity: 0;
          .el-upload{
            width: 100%;
            button{
              width: 100%;
              padding-left: 0;
            }
          }
        }
      }
    }
    .operationSearch{
      float:right;
      padding-right: 51px;
      position: relative;
      .shaixuan{
        color: #999999;
        height: 15px;
        width: 15px;
        position: relative;
        top: 2px;
        margin-left: 10px;
        margin-right: 10px;
        font-weight: 600;
      }
      .shaixuan1{
        color: #3BC6B9;
      }
      .el-input{
        width: 160px;
        .el-input__inner{
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
  }
  .tableParent{
    height: calc( 100% - 98px );
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
.store .drawerTitle{
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:25px;
  margin-bottom: 20px;
}
.store .drawerText{
  height:16px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:16px;
  margin-bottom: 5px;
}
.cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
.el-button--primary{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
  margin-left: 10px;
}
.el-button--primary:hover{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
}
/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #3BC6B9 !important;
  border-color: #3BC6B9 !important;
}*/
// 对于树组件配置特有的css
.el-tree-node>.el-tree-node__children{
  overflow: unset;
}
.el-tree-node__content{
  height: 48px;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background-color: #F6F6F6
}
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
//   color: #3BC6B9 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
//   color: #3BC6B9 !important;
// }
// 更改表格的滚动条样式
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
// 抽屉组件样式修改
.el-drawer.rtl{
  outline: none;
}
.el-drawer__wrapper{
  top: 172px;
  bottom: 18px;
/*  right: 20px;*/
}
section.el-drawer__body{
  padding: 20px;
  .el-input{
    margin-bottom: 15px;
  }
}
.el-drawer__container{
  outline: none;
}
.colorG{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(59,198,185,1);
  line-height:20px;
}
.el-table .descending .sort-caret.descending{
}
.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #3BC6B9;
}
.el-pager li.active{
  color: #3BC6B9;
}
.el-table__fixed-body-wrapper .el-table__body{
    padding-bottom: 10px;
}
.filterContent{
  height: calc(100% - 154px);
  overflow: hidden;
  overflow-y: auto;
}
.filterContent::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.filterContent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.filterContent::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.el-table-column--selection{
  text-align: center !important;
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
/*.table-fixed{
  .el-table__fixed-right{
    height:100% !important;
    right: 0 !important;
  }
  .el-table__fixed{
    height: 100% !important;
  }
}*/
.ExcalDialog{
  .el-dialog{
    width: 1000px !important;
    .el-dialog__body{
      height: 350px;
      overflow-y: auto;
    }
    .checkFiled{
      height: 100%;
      border-right: 1px solid #D8DCE6;
      width: calc(70% - 21px);
      padding-right: 20px;
      float: left;
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DCE6;
        margin-bottom: 15px;
      }
      .contentTop{
        margin-bottom: 15px;
      }
      .el-checkbox{
        margin-bottom: 15px;
      }
    }
    .showFiled{
      width: calc(30% - 20px);
      float: left;
      padding-left: 20px;
      li{
        margin-top: 10px;
        position: relative;
        span{
          padding-right: 20px;
          display: block;
        }
        .el-icon-close{
          position: absolute;
          right: 0;
          top: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
